import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const SimpleAmped15AhLifePO4WithCharger = () => {
  console.log('🎯 SimpleAmped15AhLifePO4WithCharger component loading');
  
  const product = findProductById("amped-15ah-lifepo4-with-charger");
  
  if (!product) {
    console.error('Product not found:', "amped-15ah-lifepo4-with-charger");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="amped-15ah-lifepo4-with-charger"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default SimpleAmped15AhLifePO4WithCharger; 